module.exports = __webpack_public_path__ + "static/media/PHOTO-2020-07-22-21-12-24.fc8595ab.jpg";